import { useContext } from "react";

import AppContext from "../context/AppContext";

const useRegulatorManager = (): boolean =>
  useContext(AppContext)?.adminRegulatorManager === true;

export default useRegulatorManager;
